import request from '@/utils/request';
import { datasetEndpoint, endpoints } from '@/constants/urls';

const dataModels = (
  filter,
  page,
  pageSize,
  orderBy,
) => {
  const params = { filter, page, pageSize };

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return request({
    method: 'GET',
    params,
    url: endpoints.DATA_MODELS,
  });
};

const datasetDataModel = (code) => (
  request({
    method: 'GET',
    url: `${datasetEndpoint(code)}/datamodel`,
  })
);

const updateDatasetDataModel = (code, updates) => (
  request({
    data: updates,
    method: 'PATCH',
    url: `${datasetEndpoint(code)}/datamodel`,
  })
);

const DataModelService = {
  dataModels,
  datasetDataModel,
  updateDatasetDataModel,
};

export default DataModelService;
